import { apiClient } from "./core/client";
import type { JobDto, CustomerDto, VehicleDto, UserDto, PaginatedResponse } from "@/types/dto";

export interface JobWithRelations extends JobDto {
  customer: CustomerDto | null;
  vehicle: VehicleDto | null;
  assignee: UserDto | null;
}

export interface CreateJobPayload {
  customerId?: string | null;
  vehicleId?: string | null;
  assignedTo?: string | null;
  status?: string;
  description?: string | null;
  diagnosis?: string | null;
  estimatedCompletion?: string | null;
  notes?: string | null;
}

export type UpdateJobPayload = Partial<CreateJobPayload> & {
  actualCompletion?: string | null;
};

export async function getJobs(params?: {
  page?: number;
  limit?: number;
  search?: string;
  vehicleId?: string;
  customerId?: string;
  status?: string;
}) {
  const { data } = await apiClient.get<PaginatedResponse<JobWithRelations>>(
    "/api/jobs",
    { params }
  );
  return data;
}

export async function getJob(id: string) {
  const { data } = await apiClient.get<JobWithRelations>(`/api/jobs/${id}`);
  return data;
}

export async function createJob(payload: CreateJobPayload) {
  const { data } = await apiClient.post<JobWithRelations>("/api/jobs", payload);
  return data;
}

export async function updateJob(id: string, payload: UpdateJobPayload) {
  const { data } = await apiClient.patch<JobWithRelations>(`/api/jobs/${id}`, payload);
  return data;
}

export async function deleteJob(id: string) {
  await apiClient.delete(`/api/jobs/${id}`);
}
